'use strict';

var React = require('react');
var makeStyles = require('../../Styles/makeStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var useStyles = makeStyles["default"](function (theme) {
  return {
    indicator: {
      position: 'absolute',
      display: 'block',
      backgroundColor: theme.palette['black'].primary,
      width: theme.spacing(0.25),
      height: theme.spacing(2),
      left: theme.spacing(3),
      top: function top(_ref) {
        var verticalStartingPosition = _ref.verticalStartingPosition;
        return verticalStartingPosition;
      },
      transition: theme.transitions.create('top', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shortest
      })
    }
  };
});

var LeftNavigationIndicator = function LeftNavigationIndicator(_ref2) {
  var verticalStartingPosition = _ref2.verticalStartingPosition;

  var _useStyles = useStyles({
    verticalStartingPosition: verticalStartingPosition
  }),
      indicator = _useStyles.indicator;

  return React__default["default"].createElement("span", {
    className: indicator
  });
};

module.exports = LeftNavigationIndicator;
